import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownKeyboardHints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V14C23.5 15.933 21.933 17.5 20 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4C0.5 2.067 2.067 0.5 4 0.5Z",
			stroke: "#D9D9D9",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3366 10.7755C12.1869 11.0347 11.8127 11.0347 11.6631 10.7755L9.61286 7.22445C9.46318 6.96519 9.65028 6.64111 9.94965 6.64111L14.05 6.64111C14.3494 6.64111 14.5365 6.96519 14.3868 7.22445L12.3366 10.7755Z",
			fill: "#262626"
		})
	]
});
const ForwardRef = forwardRef(SvgDownKeyboardHints);
export { ForwardRef as ReactComponent };
